import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from '@/hooks/use-translation';
import { Stepper } from '../stepper/Stepper';
export interface ValueSelectorProps<T> {
  currentValue?: T;
  onChange: (value: T) => void;
  values: {
    value: T;
    label: string;
  }[];
}
export const ValueSelector = t0 => {
  const $ = _c(36);
  const {
    currentValue,
    onChange,
    values
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  bb0: {
    if (!currentValue) {
      t1 = 0;
      break bb0;
    }
    let t2;
    if ($[0] !== currentValue || $[1] !== values) {
      let t3;
      if ($[3] !== currentValue) {
        t3 = value => value.value === currentValue;
        $[3] = currentValue;
        $[4] = t3;
      } else {
        t3 = $[4];
      }
      t2 = values.findIndex(t3);
      $[0] = currentValue;
      $[1] = values;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const index = t2;
    t1 = index !== -1 ? index : 0;
  }
  const currentValueIndex = t1;
  const currentLabel = values[currentValueIndex]?.label ?? "";
  let t2;
  if ($[5] !== values) {
    t2 = Math.max(...values.map(_temp));
    $[5] = values;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const maxValueLength = t2;
  const estimatedWidth = Math.max(maxValueLength * 0.7, 4);
  const canGoNext = currentValueIndex < values.length - 1;
  let t3;
  if ($[7] !== canGoNext || $[8] !== currentValueIndex || $[9] !== onChange || $[10] !== values) {
    t3 = () => {
      if (!canGoNext) {
        return;
      }
      onChange(values[currentValueIndex + 1].value);
    };
    $[7] = canGoNext;
    $[8] = currentValueIndex;
    $[9] = onChange;
    $[10] = values;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleGoNext = t3;
  const canGoPrevious = currentValueIndex > 0;
  let t4;
  if ($[12] !== canGoPrevious || $[13] !== currentValueIndex || $[14] !== onChange || $[15] !== values) {
    t4 = () => {
      if (!canGoPrevious) {
        return;
      }
      onChange(values[currentValueIndex - 1].value);
    };
    $[12] = canGoPrevious;
    $[13] = currentValueIndex;
    $[14] = onChange;
    $[15] = values;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const handleGoPrevious = t4;
  let t5;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ChevronRight className="size-[17px]" />;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t) {
    t6 = t("Next value");
    $[18] = t;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChevronLeft className="size-[17px]" />;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t) {
    t8 = t("Previous value");
    $[21] = t;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const t9 = `${estimatedWidth}rem`;
  let t10;
  if ($[23] !== t9) {
    t10 = {
      width: t9
    };
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== currentLabel || $[26] !== t10) {
    t11 = <span className="flex h-10 items-center justify-center px-2 font-mono text-base font-medium" style={t10}>{currentLabel}</span>;
    $[25] = currentLabel;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== canGoNext || $[29] !== canGoPrevious || $[30] !== handleGoNext || $[31] !== handleGoPrevious || $[32] !== t11 || $[33] !== t6 || $[34] !== t8) {
    t12 = <Stepper canGoNext={canGoNext} canGoPrevious={canGoPrevious} nextIcon={t5} nextLabel={t6} onNext={handleGoNext} onPrevious={handleGoPrevious} previousIcon={t7} previousLabel={t8}>{t11}</Stepper>;
    $[28] = canGoNext;
    $[29] = canGoPrevious;
    $[30] = handleGoNext;
    $[31] = handleGoPrevious;
    $[32] = t11;
    $[33] = t6;
    $[34] = t8;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
};
function _temp(value_0) {
  return String(value_0.label).length;
}